import React from "react";
import PropTypes from "prop-types";
import HistoryIcon from "@material-ui/icons/History";
import clsx from "clsx";
import { getFormattedDate } from "../../../../../Utils/Helpers/dateUtils";
import useStyles from "./ProfessionalContacts.styles";

const DeletedAddressesHistory = ({ deletedAddresses }) => {
  const classes = useStyles();
  if (!deletedAddresses || deletedAddresses.length === 0) return null;

  return (
    <>
      <div className={classes.sectionHeading}>
        <HistoryIcon fontSize="inherit" /> Deleted addresses (
        {deletedAddresses.length})
      </div>
      {deletedAddresses.map((address, index) => (
        <div
          key={`${address.postcode}-${index}`}
          className={clsx(classes.rowItem, classes.rowItemDeleted)}
        >
          <div className={classes.rowGrow}>
            <span className={classes.strikethrough}>
              {[
                address.building,
                address.street,
                address.town,
                address.postcode,
              ]
                .filter(Boolean)
                .join(", ") || "(no address)"}
            </span>
          </div>
          <span className={classes.rowMeta}>
            Removed {getFormattedDate(address.deletedUtc, "DD/MM/YYYY, HH:mm") || "-"}
            {getFormattedDate(address.deletedUtc, "DD/MM/YYYY, HH:mm") || "—"}
            {address.deletedBy ? (
              <>
                <br />
                by {address.deletedBy}
              </>
            ) : null}
          </span>
        </div>
      ))}
 	<div className={classes.hint}>Retained for audit. Deleted bank accounts are no longer selectable anywhere.</div>
    </>
  );
};

DeletedAddressesHistory.propTypes = {
  deletedAddresses: PropTypes.array,
};

export default DeletedAddressesHistory;
